import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useGlobalDrawer } from 'components/drawers/global-drawer/global-drawer.hooks';
import UtilityDrawerFooter from 'components/drawers/utility-drawer/utility-drawer-footer/utility-drawer-footer.component';
import { RelatedLocationsDrawerDataType } from '../related-locations-drawer.component';

type ButtonsSectionProps = {
  relatedLocation: RelatedLocationsDrawerDataType;
};

const ButtonsSection = ({ relatedLocation }: ButtonsSectionProps) => {
  const { t } = useTranslation();

  const { open: openCreateRelatedLocationDrawer } = useGlobalDrawer(
    'globalCreateRelatedLocationDrawer',
  );
  const { close: closeRelatedLocationDrawer } = useGlobalDrawer(
    'globalRelatedLocationsDrawer',
  );
  const { primaryLocation } = relatedLocation?.ordering ?? {};

  return (
    <UtilityDrawerFooter>
      <Stack spacing={1}>
        {primaryLocation && (
          <Button
            fullWidth
            onClick={() => openCreateRelatedLocationDrawer(relatedLocation)}
            data-testid="RelatedLocationsDrawer.Button.AddSecondaryLocation"
          >
            {t('drawer.relatedLocationsDrawer.buttons.addSecondaryLocation')}
          </Button>
        )}

        <LoadingButton
          fullWidth
          onClick={closeRelatedLocationDrawer}
          variant="outlined"
          data-testid="RelatedLocationsDrawer.Button.Close"
        >
          {t('drawer.relatedLocationsDrawer.buttons.close')}
        </LoadingButton>
      </Stack>
    </UtilityDrawerFooter>
  );
};

export default ButtonsSection;
